<template>
  <section class="gallery page" v-show="obj.open">
    <div class="prev" @click="change(-1)"></div>
    <div class="next" @click="change(1)"></div>
    <div class="close" @click="close"></div>
    <transition-group tag="div" mode="out-in" :duration="1000"
        @before-enter="beforeEnter" @enter="enter" @leave="leave" >
      <v-touch tag="img" class="slide" v-for="image, i in images" v-bind:key="image"
          v-show="i == obj.selected"
          v-on:swipeleft="change(1)" v-on:swiperight="change(-1)" :src="'/dist/' + image">
      </v-touch>
    </transition-group>


    <div class="controls">
      <span v-for="image,i in images" @click="select(i)"
            :class="{active: i == obj.selected}" class="dot">
      </span>
    </div>
  </section>
</template>

<script>
  require.context('../../assets/', true);

  export default {
    components: {},
    props: {
      id: String,
      name: String,
      images: Array,
      obj: Object
    },

    data () {
      return {
        dir: false
      }
    },

    watch: {
      'obj.open': {
        handler: function () {
          this.preventScroll();
          // TODO: Figure out how to me this work more reliably
          if (this.$el.requestFullscreen) {
            this.obj.open ? this.$el.requestFullscreen() : this.$el.exitFullscreen();
          }
        }
      }
    },

    created: function () {
      window.addEventListener('keyup', this.eventHandler, this.name);
      this.obj.open = false;
    },


    methods: {
      select: function (index) {
        this.obj.selected = index;
      },

      change: function (dir) {
        this.dir = dir;
        let l = this.images.length;
        this.obj.selected = (((this.obj.selected + dir) % l) + l) % l;
      },

      close: function () {
        this.obj.open = false;
      },

      preventScroll: function () {
        document.documentElement.style.overflow = this.obj.open ? 'hidden' : 'auto';
      },

      /**
       * Handle keyboard events.
       * @param e
       */
      eventHandler: function (e) {
        if (!this.obj.open) {
          return;
        }
        if (e.keyCode === 39) {
          this.change(1);
        } else if (e.keyCode === 37) {
          this.change(-1);
        } else if (e.keyCode === 27 || e.keyCode === 8) {
          this.close();
        }
      },

      beforeEnter: function (el) {
        el.style.opacity = 0;
        el.style.left = this.dir === -1 ? '150%' : '-50%';
        el.style.translateY = '0';
      },

      enter: function (el, done) {
        Velocity(el, {
          opacity: 1,
          left: '50%',
          translateX: '-50%',
          translateY: '-50%',
        }, { duration: 500 }, { complete: done })
      },


      leave: function (el, done) {
        Velocity(el, {
          left:  this.dir === -1 ? '-50%' : '150%',
          translateX: '-50%',
          translateY: '0',
          opacity: 0,
        }, { duration: 500 }, { complete: done })
      },
    }
  }
</script>

<style lang="scss">
  @import "../../css/main.scss";
  @import "../../css/gallery.scss";
</style>


// WEBPACK FOOTER //
// galery.vue?c19b31c2